<template>
  <div class="panorama-point-spot">
    <div class="panorama-point-spot__container">
      <div
        :class="{
          'panorama-point-spot__marker': true,
          'panorama-point-spot__marker--opened': opened
        }"
        @touchstart.stop="() => (() => {})() /* ฅ^•ﻌ•^ฅ */"
      >
        <slot />
        <div class="panorama-point-spot__hint">
          <div class="panorama-point-spot__hint-body">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanoramaPointSpot',
  props: {
    hint: {
      type: String
    },
    opened: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.panorama-point-spot {
  &__container {
    position: relative;
    width: 1px;
    height: 1px;
  }
  &__marker {
    position: absolute;
    cursor: pointer;
    height: 44px;
    width: 38px;
    left: -20px;
    bottom: 0;
    outline: none;
    @media screen and (min-width: 1920px) {
      left: -1vw;
      &, & > svg {
        height: 2.3vw;
        width: 2.1vw;
      }
    }
  }

  &:hover,
  &:focus {
    z-index: 2;
  }

  &:hover &,
  &:focus &,
  &__marker--opened & {
    &__hint {
      opacity: 1;
    }
  }

  &__hint {
    pointer-events: none;
    opacity: 0;
    position: absolute;
    bottom: 50px;
    left: -100px;
    right: -100px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 600ms ease-in-out;

    @media screen and (min-width: 1920px) {
      bottom: 2.7vw;
      left: -5.4vw;
      right: -5.4vw;
    }

    &-body {
      font-family: var(--panorama-first-font);
      font-weight: bold;
      font-size: 14px;
      line-height: 100%;

      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: var(--panorama-text-color);
      padding: 6px 10px 4px 10px;

      background: var(--panorama-background-color);
      border-radius: 8px;
      @media screen and (min-width: 1920px) {
        border-radius: 0.42vw;
        font-size: 0.75vw;
        padding: 2.5% 4% 1.6% 4%;
      }
    }
  }

  &__icon {
    position: relative;
    left: 4px;
    top: -45px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
